<template>
  <div class="main-page">
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12">
            <template v-if="!loading && item">
              <div v-if="this.item.first_programme_programme_title" class="row q-col-gutter-x-md">
                <div class="col-12">
                  <DataTable :value="[
                      {
                        pragrammeName:
                          this.item.first_programme_programme_title,
                        pragrammeStatus: this.item.first_programme_status,
                        offerStatus: !this.item.first_programme_admission_status
                          ? this.pending
                          : this.item.first_programme_admission_status,
                      },
                      {
                        pragrammeName:
                          this.item.second_programme_programme_title,
                        pragrammeStatus: this.item.second_programme_status,
                        offerStatus: !this.item
                          .second_programme_admission_status
                          ? this.pending
                          : this.item.second_programme_admission_status,
                      },
                      {
                        pragrammeName:
                          this.item.third_programme_programme_title,
                        pragrammeStatus: this.item.third_programme_status,
                        offerStatus: !this.item.third_programme_admission_status
                          ? this.pending
                          : this.item.third_programme_admission_status,
                      },
                    ]" :showGridlines="false" :rowHover="true" :resizableColumns="false" columnResizeMode="expand"
                    responsiveLayout="scroll">
                    <Column field="pragrammeName" header="Programme Title"></Column>
                    <Column field="offerStatus" header="Status">
                      <template #body="slotProps">
                        <Badge size="medium" style="font-size: 0.8rem" class="px-3" :value="slotProps.data.offerStatus"
                          :severity="
                            slotProps.data.offerStatus == pending
                              ? 'warning'
                              : slotProps.data.offerStatus == accepted
                              ? 'success'
                              : 'danger'
                          "></Badge>
                      </template>
                    </Column>
                    <Column field="action" header="Decision">
                      <template #body="slotProps">
                        <Button label="Accept" class="p-button-success p-button-text mx" :class="
                            slotProps.data.offerStatus == pending
                              ? 'text-green-500 font-bold'
                              : 'text-blue-200'
                          " style="font-size: 13px" :disabled="
                            slotProps.data.offerStatus == pending ? false : true
                          " @click="
                            confirmDecision(
                              slotProps.data.pragrammeStatus,
                              'accept'
                            )
                          " />
                        <Button label="Reject" class="p-button-danger p-button-text mx" :class="
                            slotProps.data.offerStatus == pending
                              ? 'text-red-500 font-bold'
                              : 'text-blue-200'
                          " style="font-size: 13px" :disabled="
                            slotProps.data.offerStatus == pending ? false : true
                          " @click="
                            confirmDecision(
                              slotProps.data.pragrammeStatus,
                              'reject'
                            )
                          " />
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
              <div v-else class="text-gray-500">Not available</div>
            </template>
            <!-- page loading indicator -->
            <template v-if="loading">
              <div v-show="loading" class="flex align-items-center justify-content-center text-gray-500">
                <div>
                  <ProgressSpinner style="width: 30px; height: 30px" />
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import { defineAsyncComponent, ref } from "vue";
  import { PageMixin } from "../../mixins/page.js";
  import { ViewPageMixin } from "../../mixins/viewpage.js";
  import { mapActions, mapGetters, mapState } from "vuex";
  export default {
    name: "programmeselectionsApplicantsPage",
    components: {},
    mixins: [PageMixin, ViewPageMixin],
    props: {
      pageName: {
        type: String,
        default: "applicants",
      },
      idName: {
        type: String,
        default: "applicant_id",
      },
      routeName: {
        type: String,
        default: "applicantsprogrammeselections",
      },
      pagePath: {
        type: String,
        default: "applicants/programmeselections",
      },
      apiPath: {
        type: String,
        default: "applicants/programmeselections",
      },
    },
    data() {
      return {
        item: {
          default: {},
        },
        accepted: "Accepted",
        pending: "Pending",
        completed: "Completed",
      };
    },
    computed: {
      pageTitle: {
        get: function () {
          return "Applicants Details";
        },
      },
      currentRecord: {
        get: function () {
          return this.$store.getters["applicants/currentRecord"];
        },
        set: function (value) {
          this.$store.commit("applicants/setCurrentRecord", value);
        },
      },
    },
    meta() {
      return {
        title: this.pageTitle,
      };
    },
    methods: {
      ...mapActions("applicants", ["fetchRecord"]),
      confirmDecision(programmeStatus, decision) {
        this.$confirm.require({
          message: `Are you sure you want to ${decision} application to this programme?`,
          header: "Confirmation",
          icon: "pi pi-info-circle",
          accept: () => {
            this.startProgrammeDecision(programmeStatus, decision);
          },
          reject: () => {
            //callback to execute when user rejects the action
          },
        });
      },
      async startProgrammeDecision(programmeStatus, decision) {
        let url = "applicants/programmeselections/" + this.id;
        let payload = {
          programme_status: programmeStatus,
          programme_decision: decision,
        };
        this.$api.post(url, payload).then(
          (response) => {
            this.flashMsg("Decision made successfully");
            this.load();
          },
          (response) => {
            this.showPageRequestError(response);
          }
        );
      },
    },
    watch: {
      $route(to, from) {
        //only fetch data when navigated to this page
        if (to.name == this.routeName) {
          //this.load();
        }
      },
    },
    async mounted() { },
    async created() { },
  };
</script>
<style scoped></style>